import { AUTOMATIC_SUPPORTED_UNITS, AUTOMATIC_SUPPORTED_UNITS_SCHEMA, SUPPORTED_UNITS } from '@schuettflix/interfaces';

export function toAutomaticUnit(unit: SUPPORTED_UNITS | undefined): AUTOMATIC_SUPPORTED_UNITS | undefined {
    return AUTOMATIC_SUPPORTED_UNITS_SCHEMA.safeParse(unit).data;
}
